import axiosInstance from './axiosInstance';

const getCryptoNetworkById = (cryptoNetwokId) =>
  axiosInstance.get(`/internal/admin/crypto_networks/${cryptoNetwokId}`);

export default getCryptoNetworkById;
